import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { getCorrectSuffix } from '@alfa-bank/site-form-helpers/text/get-correct-suffix';

import type { TProps, IDeps } from './models';
import { Pluralize as Component } from './component';

export const SmePartnersCommonPluralize = createWidget<IDeps, TProps>({
    getCorrectSuffix,
})(Component);
